import * as actionTypes from "./returnRequestType";

const INITIAL_STATE = {
    returnRequestList: [],
    returnRequestDetails: [],
    returnRequestCount: 0,
    returnInvoiceList: [],
    returnInvoiceItemList: [],
    statusList: [],
    returnRequestAddressList: [],
    selectedInvoice: {}
};

const returnRequestReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETRETURNREQUESTLIST:
            return {
                ...state,
                returnRequestList: action.payload.list,
            };
        case actionTypes.SETRETURNREQUEST:
            return {
                ...state,
                returnRequestDetails: action.payload.list,
            };
        case actionTypes.SETRETURNREQUESTCOUNT:
            return {
                ...state,
                returnRequestCount: action.payload.list,
            };
        case actionTypes.SETRETURNINVOICELIST:
            return {
                ...state,
                returnInvoiceList: action.payload.list,
            };
        case actionTypes.SETRETURNINVOICEITEMLIST:
            return {
                ...state,
                returnInvoiceItemList: action.payload.list,
            };
        case actionTypes.SETRETURNREQUESTADDRESSLIST:
            return {
                ...state,
                returnRequestAddressList: action.payload.list,
            };
        case actionTypes.SETSELECTEDINVOICE:
            return {
                ...state,
                selectedInvoice: action.payload,
            };
        case actionTypes.SETSTATUSLIST:
            return {
                ...state,
                statusList: action.payload.list,
            };
        default:
            return state;
    };
};

export default returnRequestReducer;